import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { ContextMenuModule } from '@ctrl/ngx-rightclick';

import { CoreModule } from '../@core/core.module';
import { CoreCommonModule } from '../@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '../@core/components';
import { CardSnippetModule } from '../@core/components/card-snippet/card-snippet.module';

import { coreConfig } from '../app/app-config';
import { AuthGuard } from '../app/auth/helpers/auth.guards';
import { JwtInterceptor, ErrorInterceptor } from '../app/auth/helpers';
import { AppComponent } from '../app/app.component';
import { LayoutModule } from '../app/layout/layout.module';
import { ContentHeaderModule } from '../app/layout/components/content-header/content-header.module';
import { CommonModule } from './main/common/common.module';
import { AuthenticationModule } from './main/authentication/authentication.module';
import { ElementsModule } from './main/elements/elements.module';
import { ApplyonlineModule } from './main/apply-online/applyonline.module';
import { DirectivesModule } from './main/directives/directives.module';
import { DashboardModule } from './main/dashboard/dashboard.module';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { PagesModule } from './main/pages/pages.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyapplicationModule } from './main/my-application/myapplication.module';
import { CoeProposalModule } from './main/coe-proposal/coeproposal.module';
import { EuttcProposalModule } from './main/euttc-proposal/euttc-proposal.module';

const appRoutes: Routes = [
	{
		path: 'dashboard',
		loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'apps',
		loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'pages',
		loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'components',
		loadChildren: () => import('./main/components/components.module').then(m => m.ComponentsModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'common',
		loadChildren: () => import('./main/common/common.module').then(m => m.CommonModule),
	},
	{
		path: '',
		redirectTo: localStorage.getItem('token') == null ? 'home' : '/login',
		pathMatch: 'full',
	},
	{
		path: '**',
		redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
	},
	{
		path: 'apply-online',
		loadChildren: () => import('./main/apply-online/applyonline.module').then(m => m.ApplyonlineModule),
		canActivate: [AuthGuard]
	},
    {
		path: 'coe-proposal',
		loadChildren: () => import('./main/coe-proposal/coeproposal.module').then(m => m.CoeProposalModule),
		canActivate: [AuthGuard]
	},
    {
		path: 'euttc-proposal',
		loadChildren: () => import('./main/euttc-proposal/euttc-proposal.module').then(m => m.EuttcProposalModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'my-application',
		loadChildren: () => import('./main/my-application/myapplication.module').then(m => m.MyapplicationModule),
		canActivate: [AuthGuard]
	}
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'enabled',
            relativeLinkResolution: 'legacy'
        }),
        NgbModule,
        NgSelectModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        TranslateModule.forRoot(),
        ContextMenuModule,
        CoreModule.forRoot(coreConfig),
        CoreCommonModule,
        CoreSidebarModule,
        CoreThemeCustomizerModule,
        CardSnippetModule,
        LayoutModule,
        CommonModule,
        ContentHeaderModule,
        AuthenticationModule,
        ElementsModule,
        ApplyonlineModule,
        CoeProposalModule,
        EuttcProposalModule,
        MyapplicationModule,
        DirectivesModule,
        DashboardModule,
        PagesModule,
        NgHttpLoaderModule.forRoot(),
        //HashLocationStrategy, 
        //RouterModule.forRoot(appRoutes, { useHash: true })
        RouterModule.forRoot(appRoutes, { useHash: false })
    ],
    exports: [RouterModule],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
